import { Theme } from "@mui/material/styles";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
export const bundlesStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      overflow: "hidden",
      padding: theme.spacing(0, 3),
    },
    mainTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      marginBottom: "40px",
    },
    centerSection: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      textAlign: "center",
    },
    discount: {
      color: "#43C311",
    },
    price: {
      textDecoration: "line-through",
      color: "#FF0000",
    },
    imageSection: {
      backgroundColor: "#FFFFFF",
      borderRadius: "20px",
      boxShadow: "4px 8px 34px 10px rgba(1, 26, 25, 0.1)",
      margin: 30,
    },
    marginBelow: {
      marginBottom: "40px",
    },
    image: {
      height: 300,
      width: "95%",
      marginTop: 6,
    },
  })
);
